// 簡單對話框（原生 <dialog>：焦點困住、Esc 關閉、背景不可互動）。
import { useEffect, useId, useRef, type ReactNode } from 'react';

export function Dialog({ open, title, onClose, children, wide, drawer, testId }: { open: boolean; title: string; onClose(): void; children: ReactNode; wide?: boolean; drawer?: boolean; testId?: string }) {
  const ref = useRef<HTMLDialogElement>(null);
  // 標題 id 每個對話框各自一個：疊兩層（例：對話框裡的操作跳重新驗證）時，名稱不會指到別層的標題
  const titleId = useId();
  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (open && !d.open) {
      if (typeof d.showModal === 'function') d.showModal();
      else d.setAttribute('open', '');
    }
    if (!open && d.open) {
      if (typeof d.close === 'function') d.close();
      else d.removeAttribute('open');
    }
  }, [open]);
  return (
    <dialog
      ref={ref}
      className={'dialog' + (wide ? ' dialog-wide' : '') + (drawer ? ' dialog-drawer' : '')}
      data-testid={testId}
      aria-labelledby={titleId}
      onCancel={(e) => {
        e.preventDefault();
        onClose();
      }}
    >
      {open && (
        <>
          <div className="dialog-head">
            <h2 id={titleId}>{title}</h2>
            <button type="button" className="icon-btn" aria-label="close" onClick={onClose}>
              ×
            </button>
          </div>
          <div className="dialog-body">{children}</div>
        </>
      )}
    </dialog>
  );
}
